var objs = {

}
const requireComponent = require.context('.',true,/^\.\/*\/[\w-]+\/index.js$/);
requireComponent.keys().forEach(fileName => {
    var name = fileName.split("/")[1];
    objs[name] = requireComponent(fileName).default
})
export default objs;


// WEBPACK FOOTER //
// ./src/js/backstage/index.js